import { render, staticRenderFns } from "./LogsUserGrid.vue?vue&type=template&id=a3b56c5a"
import script from "./LogsUserGrid.vue?vue&type=script&lang=js"
export * from "./LogsUserGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports